import { useState } from 'react';

import type { EntityAccess, EntityAccessPerson } from '../types/types';
import { AccessDetailsPanel } from './access-details-panel';
import { EntityTreePanel } from './entity-tree-panel';
import { EntityAccessEmptyState } from './entity-access-empty-estate';
import { PeoplePanel } from './people-panel';

export const TenantEntityAccessSection = () => {
  const [selectedPerson, setSelectedPerson] = useState<EntityAccessPerson | null>(null);
  const [selectedEntity, setSelectedEntity] = useState<EntityAccess | null>(null);

  const handleSelectPerson = (person: EntityAccessPerson) => {
    setSelectedPerson(person);
    setSelectedEntity(null);
  };

  return (
    <section className="grid grid-cols-[280px_minmax(0,1fr)] gap-4 pb-12">
      <PeoplePanel selectePerson={selectedPerson} onSelectPerson={handleSelectPerson} />
      {selectedPerson ? (
        <EntityTreePanel
          selectedPerson={selectedPerson}
          selectedEntity={selectedEntity}
          onSelectEntity={setSelectedEntity}
          detailsPanel={
            selectedEntity ? (
              <AccessDetailsPanel
                selectedPerson={selectedPerson}
                selectedEntity={selectedEntity}
                onClose={() => setSelectedEntity(null)}
              />
            ) : null
          }
        />
      ) : (
        <EntityAccessEmptyState />
      )}
    </section>
  );
};
